import {
  profileChangePhotoUrl,
  profilePassChangeUrl,
  profileUserDeleteUrl,
  profileViewUrl,
  referalHistoryUrl,
  referraIncomeUrl,
} from "../constant/Api";
import { baseApi } from "./api";

export const profileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    profileView: builder.query({
      query: () => ({
        url: profileViewUrl,
        method: "GET",
      }),
    }),
    profileChangePhoto: builder.mutation({
      query: (post) => ({
        url: profileChangePhotoUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    profilePassChange: builder.mutation({
      query: (post) => ({
        url: profilePassChangeUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    profileUserDelete: builder.mutation({
      query: (post) => ({
        url: profileUserDeleteUrl,
        method: "DELETE",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    refralHistory: builder.query({
      query: ({page, limit}) => ({
        url: `${referalHistoryUrl}?page=${page}&limit=${limit}`,
        method: "GET"
      }),
    }),
    refralIncome: builder.query({
      query: ({page, limit}) => ({
        url: `${referraIncomeUrl}?page=${page}&limit=${limit}`,
        method: "GET"
      }),
    }),
  }),
});

export const {
  useProfileViewQuery,
  useProfileChangePhotoMutation,
  useProfilePassChangeMutation,
  useProfileUserDeleteMutation,
  useRefralHistoryQuery,
  useRefralIncomeQuery
} = profileApi;
